@if (showSplash()) {
  <div class="splash-screen" [class.fade-out]="fadeOut()">
    <app-hcm-tile-splash />
  </div>
}
